import React from "react";
import { Doughnut } from "react-chartjs-2";

const GraficoDonutJuicio = (props) => {
  const { item } = props;

  const juicio = parseInt(item["Juicio"] || 0);
  const juicioNoApto = parseInt(item["Juicio NoApto"] || 0);
  const juicioRojo = parseInt(item["Juicio Rojo"] || 0);

  // Sin Riesgo = Juicio
  // Riesgo de Juicio = Juicio NoApto - Juicio Rojo
  // Riesgo Crítico de Juicio = Juicio Rojo
  const sinRiesgo = juicio;
  const riesgoNoApto = juicioNoApto - juicioRojo;
  const riesgoJuicio = juicioRojo;

  const _data = {
    labels: ["Sin Riesgo", "Riesgo de Juicio", "Riesgo Crítico de Juicio"],
    datasets: [
      {
        data: [sinRiesgo, riesgoNoApto, riesgoJuicio],
        backgroundColor: [
          "rgba(18, 135, 171, 0.8)", // Azul
          "rgb(210, 196, 187)", // Marrón/beige
          "rgb(198, 107, 106)", // Rojo
        ],
        borderColor: [
          "rgba(18, 135, 171, 1)",
          "rgb(180, 166, 157)",
          "rgb(178, 87, 86)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const _options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          font: { size: 11, weight: "bold" },
          padding: 12,
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets[0].data.map((data, i) => ({
              text: `${data} : ${chart.data.labels[i]}`,
              fillStyle: datasets[0].backgroundColor[i],
              borderColor: datasets[0].borderColor[i],
              borderWidth: 3,
              index: i,
            }));
          },
        },
      },
      title: {
        display: false,
      },
    },
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Doughnut data={_data} options={_options} />
    </div>
  );
};

export default GraficoDonutJuicio;
